export class ListDashboardsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dashboards",
            "baseName": "dashboards",
            "type": "Array<Dashboard>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDashboardsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
